<script setup>
import { onBeforeMount, onMounted, onUnmounted, onUpdated} from "vue";
import TransactionsRow from "../components/TransactionsRow.vue";
import setTooltip from "../assets/js/tooltip";
import validSession from "../assets/js/valid-session.js";
import { useStore } from "vuex";
import axios from "axios";
import bootstrap from "bootstrap/dist/js/bootstrap";
import { toast } from 'vue3-toastify';
import 'animate.css';
import { useRoute } from "vue-router";
import SkeletonLoad from "../components/SkeletonLoad.vue";
import { computed } from "vue";
import emitter from "../assets/js/eventBus.js";
import startResize from "../assets/js/resize.js";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

let meses = [
        t('message.global.month.jan'),
        t('message.global.month.feb'),
        t('message.global.month.mar'),
        t('message.global.month.apr'),
        t('message.global.month.may'),
        t('message.global.month.jun'),
        t('message.global.month.jul'),
        t('message.global.month.aug'),
        t('message.global.month.sep'),
        t('message.global.month.oct'),
        t('message.global.month.nov'),
        t('message.global.month.dec')
    ];

const store = useStore();
const route = useRoute();

const darkMode = computed(() => store.state.darkMode);

onBeforeMount(() => {

    validSession.isLogged();

    store.state.transaction_value = {
        value: 0
    }

    if(route.query.day){
        console.log(route.query.day);
    }

    store.state.accounts = [];
    store.state.cards = [];
    store.state.transations = [];
    store.state.categoriesExpense = {};
    store.state.categoriesRevenue = {};
    //store.state.loadingTransactions = true;
    store.state.savingTransaction = false;
    store.state.modalColor = '';
    store.state.objetives = [];
    store.state.suggestions = [];

    store.state.selectedYear = new Date().getFullYear();
    store.state.selectedMonth = {
        index: new Date().getMonth(),
        number: new Date().getMonth() + 1,
        display: meses[new Date().getMonth()]
    };

    store.state.validation = {
        descHasError: false,
        descMessageError: '',
    };

    let day = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();

    store.state.current_date = year+ '-' + (month < 10 ? '0'+month : month) + '-' + (day < 10 ? '0'+ day : day);

    store.state.transation = {
        type: '',
        description: '',
        amount: 0,
        date: store.state.current_date,
        account: '',
        account_name: '',
        account_destiny: '',
        account_destiny_name: '',
        category: '',
        category_name: '',
        category_icon: '',
        category_color: '',
        recurrence_checked: false,
        recurrence: '',
        recurrence_period: 'monthly',
        initial_installment: 1,
        current_installment: 1,
        end_installment: 1,
        payed: false,
        id: '',
        transaction_id: '',
        invoice_id: '',
        card_id: '',
        howUpdate: '',
        amount_paid: 0,
        ammount_unpaid: 0,
        observation: '',
        objetive_checked: false,
        objetive: '',
        customer_supplier: ''
    }

    store.state.balance = 0;
    store.state.loading_balance = true;
    store.state.foreseen_revenue = 0;
    store.state.revenue_done = 0;
    store.state.foreseen = 0;
    store.state.foreseen_expense = 0;
    store.state.expense_done = 0;

    store.state.invoice_id = route.params.id;

    store.state.filter = {
        account: '',
        status: '',
        type: '',
        startDay: route.query.day ? route.query.day : '',
        endDay: route.query.day ? route.query.day : ''
    }

    store.state.filtered = 0;

    store.state.loadingTransactions = true;
    getTransaction(false);
    getCards();
    getAccounts();
    getExpenseCategories();
    getRevenueCategories();
    getObjetives();

})

const reload_data = (res) => {

    getTransaction(res.editing, res.transaction_id);
};

onMounted(() => {

    emitter.on('load-data', reload_data);
    
    setTooltip();

    

});

onUpdated(() => {
    if(!store.state.loadingTransactions){
        startResize();
    }
});

onUnmounted(() => {
    emitter.off('load-data', reload_data);
});

const getTransaction = async () => {
    

    let period = store.state.selectedYear + '-' + (store.state.selectedMonth.number < 10 ? '0' + store.state.selectedMonth.number : store.state.selectedMonth.number);
    let account = store.state.filter.account;
    let status = store.state.filter.status;
    let type = store.state.filter.type;
    let dayStart = store.state.filter.startDay;
    let dayEnd = store.state.filter.endDay;

    axios.get('transactions?period='+period+'&account='+account+'&status='+status+'&type='+type+'&dayStart='+dayStart+'&dayEnd='+dayEnd)
    .then(res => {
        
        if(res.status == 200){

            store.state.transations = res.data;
            store.state.loadingTransactions = false;

            getBalance();

            

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getAccounts = async () => {

    axios.get('accounts?archived=No')
    .then(res => {
        
        if(res.status == 200){

            store.state.accounts = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getCards = async () => {

    axios.get('credit-cards')
    .then(res => {
        
        if(res.status == 200){

            store.state.cards = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getExpenseCategories = async () => {

    axios.get('categories?type=despesa')
    .then(res => {
        
        if(res.status == 200){

            store.state.categoriesExpense = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getRevenueCategories = async () => {

    axios.get('categories?type=receita')
    .then(res => {

    if(res.status == 200){

        store.state.categoriesRevenue = res.data;

    }

    })
    .catch(err => {
        console.error(err); 
    })

}

const getBalance = async () => {

    axios.get('accounts/balance')
    .then(res => {

    if(res.status == 200){

        store.state.balance = res.data[0].balance;
        store.state.foreseen_revenue = 0;
        store.state.revenue_done = 0;
        store.state.foreseen = 0;
        store.state.foreseen_expense = 0;
        store.state.expense_done = 0;

        calc_balance();
        store.state.loading_balance = false;

    }

})
.catch(err => {
    console.error(err); 
})

}

const clearFields = () => {

    store.state.transaction_value.value = 0

    store.state.transation = {
        type: '',
        description: '',
        amount: 0,
        date: store.state.current_date,
        account: '',
        account_name: '',
        account_destiny: '',
        account_destiny_name: '',
        category: '',
        category_name: '',
        category_icon: '',
        category_color: '',
        recurrence_checked: false,
        recurrence: '',
        recurrence_period: 'monthly',
        initial_installment: 1,
        current_installment: 1,
        end_installment: 1,
        payed: false,
        id: '',
        transaction_id: '',
        invoice_id: '',
        card_id: '',
        howUpdate: '',
        amount_paid: 0,
        ammount_unpaid: 0,
        observation: '',
        objetive: '',
        customer_supplier: ''
    }

    store.state.suggestions = [];
}

const editTrasaction = (data) => {

    emitter.emit('edit-transaction', { data });
    emitter.emit('set-type', { data: data.type });

}

const payTransation = (transaction) => {

    if(transaction.type != 'transferência' && transaction.status == 'Unpaid'){

        emitter.emit('set-type', { data: transaction.type });

        store.state.transaction_value.value = formatMoney(transaction.amount);

        console.log(transaction);

        store.state.transation = {
            type: transaction.type,
            description: transaction.description,
            amount: formatMoney(transaction.amount),
            date: transaction.date,
            account: transaction.account_id > 0 ? transaction.account_id+'-bank': transaction.card_id+'-card',
            account_name: transaction.account_name,
            account_destiny: transaction.account_destiny_id > 0 ? transaction.account_destiny_id+'-bank': '',
            account_destiny_name: transaction.account_destiny_name,
            category: transaction.category_id,
            category_name: transaction.category_name,
            category_icon: transaction.category_icon,
            category_color: transaction.category_color,
            recurrence_checked: false,
            recurrence: transaction.recurrence,
            recurrence_period: '',
            initial_installment: 1,
            current_installment: transaction.current_installment,
            end_installment: transaction.end_installment,
            payed: 'Paid',
            id: transaction.id,
            transaction_id: transaction.transaction_id,
            invoice_id: transaction.invoice_id,
            card_id: transaction.card_id,
            howUpdate: 'just_this',
            amount_paid: transaction.amount_paid,
            ammount_unpaid: transaction.ammount_unpaid,
            observation: transaction.observation,
            customer_supplier: transaction.customer_suplier_id
        }

        openModal('payTransaction');
        
    }
    else{

        let url = '/transactions/pay/'+transaction.id;

        let data = new FormData();

        data.append('status', transaction.status == 'Paid' ? 'Unpaid' : 'Paid');

        axios.post(url, data)
        .then(res => {
            
            if(!res.data.error){

                toast('Transação atualizada com sucesso!', {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                getTransaction(true, transaction.id);
                clearFields();

            }

        })
        .catch(err => {
            console.error(err); 
        })

    }


}

const openModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.show();

}

const slideDate = (direction) => {

    if(direction == 'prev'){

        let prev_month = store.state.selectedMonth.index > 0 ? store.state.selectedMonth.index - 1 : 11;
        let prev_year = store.state.selectedMonth.index > 0 ? store.state.selectedYear : store.state.selectedYear - 1;
        
        store.state.selectedYear = prev_year;
        store.state.selectedMonth = {
            index: prev_month,
            number: prev_month + 1,
            display: meses[prev_month]
        };

        getTransaction();

    }
    else if(direction == 'next'){

        let next_month = store.state.selectedMonth.index < 11 ? store.state.selectedMonth.index + 1 : 0;
        let next_year = store.state.selectedMonth.index < 11 ? store.state.selectedYear : store.state.selectedYear + 1;

        store.state.selectedYear = next_year;
        store.state.selectedMonth = {
            index: next_month,
            number: next_month + 1,
            display: meses[next_month]
        };

        getTransaction();

    }

}

const formatMoney = (v) => {
    let total = parseFloat(v);

    return total.toLocaleString(t('message.global.date_language'), {
            style: "currency",
            currency: "BRL",
        });
}

const rotate = (id) => {

    let element = document.getElementById(id);

    element.classList.toggle('fa-rotate-90');

}

const calc_balance = () => {

    store.state.transations.forEach((transaction) => {

        if(transaction.type == 'despesa'){

            if(transaction.status == 'Unpaid'){

                store.state.foreseen_expense += parseFloat(transaction.amount);

            }
            else if(transaction.status == 'Paid'){

                store.state.expense_done += parseFloat(transaction.amount);

            }

        }
        else if(transaction.type == 'receita'){

            if(transaction.status == 'Unpaid'){

                store.state.foreseen_revenue += parseFloat(transaction.amount);

            }
            else if(transaction.status == 'Paid'){

                store.state.revenue_done += parseFloat(transaction.amount);

            }

        }

    });

    store.state.foreseen = (parseFloat(store.state.balance) + parseFloat(store.state.foreseen_revenue)) - parseFloat(store.state.foreseen_expense);

}

const clearFilter = () =>{

    store.state.filter = {
        account: '',
        status: '',
        type: '',
        startDay: '',
        endDay: ''
    }

    getTransaction(false);

}

const getObjetives = async () => {

    axios.get('objetives')
    .then(res => {
        
        if(res.status == 200){

            store.state.objetives = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const isFiltered = () => {

    let filtered = 0;

    if(store.state.filter.account !== ''){

        filtered += 1;

    }

    if(store.state.filter.status !== ''){

        filtered += 1;

    }

    if(store.state.filter.type !== ''){

        filtered += 1;

    }

    if(store.state.filter.startDay !== ''){

        filtered += 1;

    }

    if(store.state.filter.endDay !== ''){

        filtered += 1;

    }

    return filtered;

}

</script>
<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 default-shadow">
                <div class="row align-items-center sticky-top header-transaction pt-lg-3 pb-lg-3" :class="darkMode ? 'darkmode' : ''">
                    <div class="col-7 col-lg-4 order-2 order-lg-1 mt-n2 mt-xl-0">
                        <h6 class="mt-xl-2">{{ t('message.global.transaction', store.state.transations.length) }}</h6>
                    </div>
                    <div class="col-12 col-lg-4 text-center order-1 order-lg-2 mt-3 mb-2 mt-lg-0 mb-lg-0">
                        <div class="row">
                            <div class="col-2 col-lg-3">
                                <a class="cursor-pointer" @click="slideDate('prev')">
                                    <i class="fal fa-chevron-left me-0 me-lg-5"></i>
                                </a>
                            </div>
                            <div class="col-8 col-lg-6 mx-auto">
                                <span>
                                    {{ store.state.selectedMonth.display }} {{ store.state.selectedYear }}
                                </span>
                            </div>
                            <div class="col-2 col-lg-3">
                                <a class="cursor-pointer" @click="slideDate('next')">
                                    <i class="fal fa-chevron-right ms-0 ms-lg-5"></i>
                                </a>
                            </div>
                        </div>
                        
                        <hr class="d-lg-none">
                    </div>
                    <div class="col-5 col-lg-4 order-3">
                        
                        
                        <a class="trasation-list-add-button text-white float-end mt-n2 mt-0 mt-lg-1 mb-2 me-4" type="button" data-bs-toggle="modal" data-bs-target="#filterTransactions" v-tooltip="{
                                        content:'Filtrar',
                                        distance: 13
                                    }">
                            <i class="fal fa-filter"></i> <span class="fs-13 ms-n2">{{ isFiltered() >  0 ? isFiltered() : ''}}</span>
                        </a>
                        
                    </div>
            
                </div>

                <div id="transactionList" class="row overflow-auto" :class="!darkMode ? 'bg-white' : 'bg-222222'">

                    <div class="col-12 text-center mt-4 mb-4" v-if="store.state.loadingTransactions">
                        <div class="row">

                            <div class="col-2 col-lg-1 ms-3 text-center">
                                <SkeletonLoad
                                    :width='"40px"'
                                    :height="'40px'"
                                    :class="'rounded-circle'"
                                />
                            </div>
                            <div class="col-6 col-lg-8">
                                <div class="row align-items-center">
                                    <div class="col-12 col-lg-6">
                                        <SkeletonLoad
                                            :width="'90px'"
                                            :height="'15px'"
                                            :class="'mb-1 mb-lg-2'"
                                        />
                                        <SkeletonLoad
                                            :width="'90px'"
                                            :height="'15px'"
                                            :class="'mb-1 mb-lg-0'"
                                        />
                                    </div>
                                    <div class="col-12 col-lg-3 text-lg-center d-none d-lg-block">
                                        <SkeletonLoad
                                            :width="'90px'"
                                            :height="'15px'"
                                        />
                                    </div>
                                    <div class="col-12 col-lg-3 text-lg-center">
                                        <SkeletonLoad
                                            :width="'90px'"
                                            :height="'15px'"
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-3 col-lg-2 text-end">
                                
                                <div class="col-12 col-lg-3 text-lg-center d-lg-none mt-3">
                                    <SkeletonLoad
                                        :width="'30px'"
                                        :height="'20px'"
                                    />
                                </div>
                            </div>

                        </div>
                        
                    </div>
                    <div class="col-12 text-center mt-4" v-if="store.state.transations.length == 0 && !store.state.loadingTransactions">
                        <p>{{ t('message.global.zero_transactions') }}</p>
                    </div>

                    <div class="col-12 trasaction-list" v-if="!store.state.loadingTransactions">

                        <TransactionsRow 
                            v-for="(transation, index) in store.state.transations" :key="index"
                            :transaction = transation
                            :darkmode = darkMode
                            @edit="editTrasaction"
                            @pay="payTransation"
                        />

                    </div>

                </div>

                <div class="row footer-transaction" :class="darkMode ? 'darkmode' : ''">
                    <div class="col-12 mt-3">
                        <div class="row align-items-center">
                            <div class="col-6 col-lg-8 text-end">
                                <p class="balance-text">
                                    {{ t('message.transactions.current_balance') }}
                                    <br>
                                    {{ t('message.transactions.future_balance') }}
                                </p>
                            </div>
                            <div class="col-4 col-lg-2 text-end">
                                <SkeletonLoad
                                    v-if="store.state.loading_balance"
                                    :width="'90px'"
                                    :height="'20px'"
                                    :class="'mt-n4 mb-1 float-end'"
                                />
                                <SkeletonLoad
                                    v-if="store.state.loading_balance"
                                    :width="'90px'"
                                    :height="'20px'"
                                    :class="'float-end'"
                                />
                                <p v-if="!store.state.loading_balance" class="balance-text">
                                    <b>{{formatMoney(store.state.balance)}}</b>
                                    <br>
                                    {{formatMoney(store.state.foreseen)}}
                                </p>
                            </div>
                            <div class="col-2">
                                <a 
                                    data-bs-toggle="collapse" 
                                    href="#collapseBalance" 
                                    role="button" 
                                    aria-expanded="false" 
                                    aria-controls="collapseBalance"
                                    @click="rotate('balance_chevron')"
                                >
                                    <i id="balance_chevron" class="fal fa-chevron-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="row collapse" id="collapseBalance">

                            <div class="col-6 col-lg-8 text-end">
                                <p class="balance-text">
                                    {{ t('message.transactions.revenue_done') }}
                                    <br>
                                    {{ t('message.transactions.future_revenue') }}
                                    <br>
                                    {{ t('message.transactions.expense_done') }}
                                    <br>
                                    {{ t('message.transactions.future_expense') }}
                                </p>
                            </div>
                            <div class="col-4 col-lg-2 text-end">
                                <p class="balance-text">
                                    <span class="text-success">{{formatMoney(store.state.revenue_done)}}</span>
                                    <br>
                                    {{formatMoney(store.state.foreseen_revenue)}}
                                    <br>
                                    <span class="text-danger">{{formatMoney(store.state.expense_done)}}</span>
                                    <br>
                                    - {{formatMoney(store.state.foreseen_expense)}}
                                </p>
                            </div>
                            <div class="col-2"></div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    

    <div class="modal fade" id="filterTransactions" tabindex="-1" aria-labelledby="filterTransactions" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-4" v-bind:class="{
                        'darkmode': darkMode
                    }">

                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">

                    <div class="row">
                        <div class="col-10">
                            <b>
                                {{ t('message.transactions.filters') }}
                            </b>
                        </div>
                        <div class="col-2 text-end">
                            <a type="button" data-bs-dismiss="modal">
                                <i class="fal fa-times-circle fa-lg"></i>
                            </a>
                        </div>

                    </div>

                    <div class="row align-items-center mt-3">
            
                        <div class="col-12 mt-2 mb-2 d-inline-flex align-items-center">

                            <label for="filterAccount" class="me-2 mb-0 ms-0">{{ t('message.global.bank_account') }}</label>
                            <select 
                                v-if="store.state.accounts.length >= 1"
                                class="form-select form-select-lg" 
                                aria-label="Conta" 
                                v-model="store.state.filter.account"
                                id="filterAccount"
                                v-bind:class="{
                                    'darkmode': darkMode,
                                }"
                            >
                                    <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                                    <option
                                        v-for="(account, index) in store.state.accounts" :key="index"
                                        :value="account.id"
                                    >
                                        {{ account.name }}
                                    </option>

                            </select>

                        </div>
                        <div class="col-12 mt-2 mb-2 d-inline-flex align-items-center">

                            <label for="filterStatus" class="me-2 mb-0 ms-0">{{ t('message.transactions.status') }}</label>
                            <select 
                                v-if="store.state.accounts.length >= 1"
                                class="form-select form-select-lg" 
                                aria-label="Status" 
                                v-model="store.state.filter.status"
                                id="filterStatus"
                                v-bind:class="{
                                    'darkmode': darkMode,
                                }"
                            >
                                    <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                                    <option value="Unpaid">{{ t('message.global.not_payed') }}</option>
                                    <option value="Paid">{{ t('message.global.payed') }}</option>

                            </select>

                        </div>
                        <div class="col-12 mt-2 mb-2 d-inline-flex align-items-center">

                            <label for="filterType" class="me-2 mb-0 ms-0">{{ t('message.transactions.type') }}</label>
                            <select 
                                v-if="store.state.accounts.length >= 1"
                                class="form-select form-select-lg" 
                                aria-label="Tipo" 
                                v-model="store.state.filter.type"
                                id="filterType"
                                v-bind:class="{
                                    'darkmode': darkMode,
                                }"
                            >
                                    <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                                    <option value="receita">{{ t('message.global.revenue') }}</option>
                                    <option value="despesa">{{ t('message.global.expense') }}</option>
                                    <option value="transferencia">{{ t('message.global.transfer') }}</option>

                            </select>

                        </div>
                        <div class="col-12 mt-2 mb-2 d-inline-flex align-items-center">

                            <label for="filterDay" class="me-2 mb-0 ms-0">{{ t('message.transactions.period') }}</label>

                        </div>
                        <div class="col-6 mt-2 mb-2 d-inline-flex align-items-center">

                            <label for="filterStartDay" class="me-2 mb-0 ms-0">{{ t('message.transactions.from') }}</label>
                            <select 
                                v-if="store.state.accounts.length >= 1"
                                class="form-select form-select-lg" 
                                aria-label="Tipo" 
                                v-model="store.state.filter.startDay"
                                id="filterStartDay"
                                v-bind:class="{
                                    'darkmode': darkMode,
                                }"
                            >
                                    <option v-for="n in 31" :key="n"
                                        :value="n < 10 ? '0'+n : n"
                                    >
                                        {{n < 10 ? '0'+n : n}}
                                    </option>

                            </select>

                        </div>
                        <div class="col-6 mt-2 mb-2 d-inline-flex align-items-center">

                            <label for="filterEndDay" class="me-2 mb-0 ms-0">{{ t('message.transactions.to') }}</label>
                            <select 
                                v-if="store.state.accounts.length >= 1"
                                class="form-select form-select-lg" 
                                aria-label="Tipo" 
                                v-model="store.state.filter.endDay"
                                id="filterEndDay"
                                v-bind:class="{
                                    'darkmode': darkMode,
                                }"
                            >
                                    <option v-for="n in 31" :key="n"
                                        :value="n < 10 ? '0'+n : n"
                                    >
                                        {{n < 10 ? '0'+n : n}}
                                    </option>

                            </select>

                        </div>
                        <div class="col-lg-12 mt-2 mb-2 d-flex align-items-center justify-content-center">
                            <button class="btn btn-success mt-3" @click="getTransaction(false)" data-bs-dismiss="modal">{{ t('message.transactions.apply') }}</button>
                            <a data-bs-dismiss="modal" @click="clearFilter()" class="trasation-list-add-button text-danger float-end ms-3" type="button" v-tooltip="{
                                            content:t('message.transactions.clean_filters'),
                                            distance: 13
                                        }">
                                <i class="fal fa-eraser"></i>
                            </a>
                        </div>
                    </div>

                </div>
            
            </div>
        </div>
    </div>

</template>